// Logo.js

import { Link } from "react-router-dom";

const Logo = () => {
    return(
        <div className="logo">
            <Link to="/">
                <div className="logo-main">
                    <h1 id="logo-ajit">AJIT</h1>
                    <h1 id="logo-furniture">FURNITURE</h1>
                </div>

                <h1 id="logo-house">HOUSE</h1>
                <h3 className="logo-tagline">FURNITURE & INTERIOR DESIGNERS</h3>
            </Link>
        </div>
    )
}

export default Logo;